import { TopSalesPerformers } from './TopSalesPerformers'
import { HighestConversion } from './HighestConversion'
import { RevenueGenerators } from './RevenueGenerators'
import { MostCalls } from './MostCalls'
import { useEffect } from 'react'
import { GetRequest } from '../../../../../Utils/hooks/ApiHandler'

export const CEOSalesAndConversion = () => {
    const fetchSalesConversionData = async () => {
        try {
            const res = await GetRequest()
        } catch (error) {
            return
        }
    }
    useEffect(() => {

    }, [])
    return (
        <>
            <TopSalesPerformers />
            <HighestConversion />
            <RevenueGenerators />
            <MostCalls />
        </>
    )
}
